module.exports = __webpack_public_path__ + "img/broatcast-step2.93572290.png";